import { Reducer } from "../../lib/redux";
import { ISystemSettings, SystemSettingsActionTypes } from "./types";

export let defaultSystemSettings: ISystemSettings = {
    customCode: "",
    maxPCDistance: 0,
    companyName: "",
    companyAddress: "",
    customerPages: [],
    customExemptHOSName: "",
    customExemptHOSAbbreviation: "",
    allowUnsignedAddIn: false,
    jurisdiction: "",
    companyGuid: "",
    resellerInfo: undefined
};

export let systemSettings: Reducer<ISystemSettings> = (state = defaultSystemSettings, action): ISystemSettings => {
    switch (action.type) {
        case SystemSettingsActionTypes.SET_SYSTEMSETTINGS: {
            return action.payload;
        }
        default: {
            return state;
        }

    }
};